module.exports = "/_next/static/images/property@3x-7b65d72ffb71ff7c4f3da211cba8a756.png";